module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"separator":"、","price_per_day":"{price}/天","price_per_booking":"{price}/次","price_per_night":"{price}/晚","price_per_hour":"{price}/小時"},"en":{"separator":", ","price_per_day":"{price}/day","price_per_booking":"{price}/booking","price_per_night":"{price}/night","price_per_hour":"{price}/hour"}}')
  delete Component.options._Ctor
}
